import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar
} from "../../../../../_metronic/_partials/controls";
import { useConsolidationReportUIContext } from "./ConsolidationReportUIContext";
import { ConsolidationReportFilter } from "./consolidation-report-table/consolidation-report-filter/ConsolidationReportFilter";
import ConsolidationReportDetail from "./consolidation-report-detail/ConsolidationReportDetail";
import {
  fetchConsolidationReports,
  createConsolidationReport,
  updateConsolidationReport
} from "../../_redux/consolidation-report/consolidationReportAction";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import ConsolidationReportTable from "./consolidation-report-table/ConsolidationReportTable";
import LoadingAnimation from "./loading-animation/LoadingAnimation";
import { ConfirmationModal } from "../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import { toastOption } from "../../../../../_metronic/_helpers";
import moment from "moment";
import { Collapse } from "react-bootstrap";

export const ConsolidationReportCard = ({
  match: {
    params: { id }
  },
  history
}) => {
  // * DECLARE HOOKS
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState({
    consolidationReport: false,
    confirmation: false
  });
  const [currentItem, setCurrentItem] = useState({});
  const [openFilter, setOpenFilter] = useState(false);

  // * ConsolidationReport UI Context
  const consolidationReportUIContext = useConsolidationReportUIContext();
  const consolidationReportUIProps = useMemo(() => {
    return {
      queryParams: consolidationReportUIContext.queryParams,
      setQueryParams: consolidationReportUIContext.setQueryParams,
      openEditConsolidationReportPage:
        consolidationReportUIContext.openEditConsolidationReportPage,
      openConsolidationReportFilePage:
        consolidationReportUIContext.openConsolidationReportFilePage
    };
  }, [consolidationReportUIContext]);

  // * Getting current state of consolidationReport list from store (Redux)
  const { totalCount, entities, listLoading, actionsLoading } = useSelector(
    state => state.superAdminConsolidationReport,
    shallowEqual
  );

  useEffect(() => {
    // * Requset ke ConsolidationReport Action
    dispatch(fetchConsolidationReports(consolidationReportUIProps.queryParams));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consolidationReportUIProps.queryParams, dispatch]);

  const onSubmitConsolidationReport = status => {
    dispatch(
      createConsolidationReport({
        uuid: currentItem.uuid,
        consolidation_uuid: currentItem.consolidation_uuid,
        status: status
      })
    )
      .then(res => {
        dispatch(
          fetchConsolidationReports(consolidationReportUIProps.queryParams)
        );
        toast.success(res.data.message, toastOption);
        setOpenModal(prev => ({ ...prev, consolidationReport: false }));
        setCurrentItem({});
      })
      .catch(err => {
        toast.error(err.message);
      });
  };

  return (
    <>
      <LoadingAnimation open={actionsLoading} />
      {/* CREATE FOLDER MODAL */}
      <ConsolidationReportDetail
        show={openModal.consolidationReport}
        onHide={() => {
          setOpenModal(prev => ({ ...prev, consolidationReport: false }));
          setCurrentItem({});
        }}
        handleClickStatusReport={onSubmitConsolidationReport}
        currentItem={currentItem}
      />
      <Card>
        <CardHeader title="Laporan Konsolidasi">
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn mx-1 btn-warning"
              onClick={() => setOpenFilter(!openFilter)}
            >
              Pencarian
            </button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <Collapse in={openFilter}>
            <div id="collapse-filter-report">
              <ConsolidationReportFilter />
            </div>
          </Collapse>
          <ConsolidationReportTable
            totalCount={totalCount}
            listLoading={listLoading}
            entities={entities}
            queryParams={consolidationReportUIProps.queryParams}
            setQueryParams={consolidationReportUIProps.setQueryParams}
            openEditConsolidationReportPage={
              consolidationReportUIProps.openEditConsolidationReportPage
            }
            setCurrentItem={setCurrentItem}
            setOpenModal={setOpenModal}
          />
        </CardBody>
      </Card>
    </>
  );
};
